import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { DataProvider } from "../Components/ContextProvider";
import { jwtDecode } from "jwt-decode";

export const isTokenExpired = () => {
  const token = localStorage.getItem("token");
  if (!token) return true;
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true;
  }
};

const PrivateRoute = ({ children }) => {
  let { issetLoginDialogOpen, setisSignup, setshowotpcomponent } =
    useContext(DataProvider);
  const handleLogin = () => {
    setisSignup(false);
    setshowotpcomponent(false);
    issetLoginDialogOpen(true);
  };
  const token = localStorage.getItem("token");
  const isTokenValid = !!token; // Cleaner way to check validity

  if (!isTokenValid || isTokenExpired()) {
    handleLogin();
    return <Navigate to="/" replace />; // Return the Navigate component
  }
  return children; // Render the children if authenticated
};

export default PrivateRoute;
